import { render, staticRenderFns } from "./LassoxFeaturedAd.vue?vue&type=template&id=30185268&scoped=true"
import script from "./LassoxFeaturedAd.vue?vue&type=script&lang=js"
export * from "./LassoxFeaturedAd.vue?vue&type=script&lang=js"
import style0 from "./LassoxFeaturedAd.vue?vue&type=style&index=0&id=30185268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30185268",
  null
  
)

export default component.exports